import { store } from "store";
import {
  EAcaoLogUser,
  EGrupoAcaoLogUser,
  ELogUserStatus,
} from "@deltasge/marauders-map";
import { apiRelatorio } from "./axios";

export interface IGravaLogUser extends Record<string, any> {
  logKey: {
    chaves?: {
      group: number;
      role: number;
    };
    chavesLog?: {
      group?: number;
      role: number;
    };
    acao: EAcaoLogUser;
    grupoAcao: EGrupoAcaoLogUser;
  };
  logKeys?: {
    idAluno?: number;
    idCliente?: number;
    idResponsavel?: number;
    idProfessor?: number;
    idMatricula?: number;
    idCurso?: number;
    idSerie?: number;
    idTurma?: number;
    idMateria?: number;
    idMensalidade?: number;
    etapa?: number;
  };
  status: ELogUserStatus;
  area?: string;
  message?: string;
  deltaId?: string;
  processo?: string;
  group?: number;
  role?: number;
  dataBefore?: Record<string, any>;
  dataAfter?: Record<string, any>;
}

export const gravaLogUser = async (log: IGravaLogUser) => {
  const {
    usuario: { usuario },
    escola,
  } = store.getState();

  const chaves = log.logKeys ?? {};
  const dados = {
    deltaId: usuario?.deltaId,
    idEscola: escola.codigo,
    idUser: usuario?.id,
    acao: log.logKey.acao,
    grupoAcao: log.logKey.grupoAcao,
    descricao: log.message,
    idAluno: chaves.idAluno,
    idResponsavel: chaves.idCliente,
    idCliente: chaves.idCliente,
    idProfessor: chaves.idProfessor,
    idMatricula: chaves.idMatricula,
    idCurso: chaves.idCurso,
    idSerie: chaves.idSerie,
    idTurma: chaves.idTurma,
    idMateria: chaves.idMateria,
    idMensalidade: chaves.idMensalidade,
    etapa: chaves.etapa,
    status: log.status,
    payload: JSON.stringify({
      dataBefore: log.dataBefore,
      dataAfter: log.dataAfter,
    }),
    metadata: JSON.stringify({
      ip: "",
      navegador: window.navigator.userAgent,
      dispositivo: window.navigator.platform,
      origem: window.location.pathname,
    }),
  };

  await apiRelatorio.post(`/log-user`, dados);
};
